import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ButtonType} from "@pb-labs/button";
import {ModalComponent} from "@pb-labs/modal";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {CookiePolicyModalService} from "@app/shared/components/cookie-policy-modal/cookie-policy-modal.service";

@Component({
  selector: "app-cookie-policy-modal",
  templateUrl: "./cookie-policy-modal.component.html",
  styleUrls: ["./cookie-policy-modal.component.scss"],
})
export class CookiePolicyModalComponent implements OnInit, OnDestroy {
  readonly buttonType = ButtonType;
  @ViewChild("modal") private modal: ModalComponent;
  private destroy: Subject<void> = new Subject<void>();

  constructor(private cookiePolicyModalService: CookiePolicyModalService) {}

  ngOnInit(): void {
    this.cookiePolicyModalService
      .open$()
      .pipe(takeUntil(this.destroy))
      .subscribe(() => {
        this.modal.open();
      });
  }

  ngOnDestroy(): void {
    this.modal?.close();

    this.destroy.next();
    this.destroy.complete();
  }

  onButtonClick(): void {
    this.cookiePolicyModalService.verify();
    this.modal.close();
  }
}
